"use strict";
module.exports = {
    entityModel: 'supplierCustomerInPcsService',
    events: {
        SUPPLIER_CUSTOMER_IN_PCS_SERVICE_CREATED: 'SUPPLIER_CUSTOMER_IN_PCS_SERVICE_CREATED',
        SUPPLIER_CUSTOMER_IN_PCS_SERVICE_UPDATED: 'SUPPLIER_CUSTOMER_IN_PCS_SERVICE_UPDATED',
    },
    actions: {
        get: 'v1.supplierCustomerInPcsService.get',
        list: 'v1.supplierCustomerInPcsService.list',
        upsert: 'v1.supplierCustomerInPcsService.upsert',
        upsertWhenEmpty: 'v1.supplierCustomerInPcsService.upsertWhenEmpty',
        updateWhenEmpty: 'v1.supplierCustomerInPcsService.updateWhenEmpty',
        update: 'v1.supplierCustomerInPcsService.update',
    },
    customerTypes: {
        horeca: 'horeca',
        dvh: 'dvh',
        wholesale: 'wholesale',
        office: 'office',
        systembolaget: 'systembolaget',
        supplier: 'supplier',
        export: 'export',
        other: 'other',
    },
};
